<template>
	<div class="metric__card" :class="spanClass">
		<div class="metric__heading">
			<div>
				<div>{{metricName}}</div>
				<div v-if="metricTarget">({{metricTarget}})</div>
			</div>
			<div>$ {{metricTotal}}</div>
		</div>
		<div class="metric__details">
			<div v-for="(usage, index) in metricUsage" class="metric__det-row" :key="index">
				<span class="metric__det-name">{{metricTypes(usage.type)}}</span>
				<span class="metric__det-calc">{{metricUsageFormat(usage.usage, usage.type)}}</span>
				<span class="metric__det-price">$ {{ usage.cents / 100 | toFixed(2) }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Metric",
	props: ["fr", "metric", "allMetrics"],
	computed: {
		spanClass: function () {
			return this.fr ? "span-" + this.fr : '';
		},
		metricTotal: function() {
			return (this.metric.cents / 100).toFixed(2);
		},
		metricName: function() {
			return this.ucFirst(this.metric.metric.name.replace(/([A-Z])/g, ' $1'));
		},
		metricTarget: function() {
			return this.metric.metric.target;
		},
		metricUsage: function() {
			var list = this.metric.usage || [];
			if (this.allMetrics) {
				return list;
			}
			return list.filter(u => u.pricing);
		}
	},
	methods: {
		ucFirst(s) {
			return s.charAt(0).toUpperCase() + s.slice(1);
		},
		metricTypes(t) {
			if (!this.usageTypes) {
				this.usageTypes = {
					COUNTER: 'Count',
					MEMORY: 'Memory',
					TIMER: 'Time'
				};
			}
			return this.usageTypes[t];
		},
		metricUsageFormat(v, f) {
			if (!this.usageFormats) {
				this.usageFormats = {
					COUNTER: function(v) {
						return `${v.toLocaleString()} #`;
					},
					MEMORY: function(v) {
						var m = 'b';
						if (v > 1024) {
							v = v / 1024;
							if (v > 1024) {
								v = v / 1024;
								if (v > 1024) {
									v = v / 1024;
									m = 'Gb';
								} else {
									m = 'Mb';
								}
							} else {
								m = 'kb';
							}
							return `${v.toFixed(2)} ${m}`;
						} else {
							return `${v} ${m}`;
						}
					},
					TIMER: function(v) {
						var m = 'ms';
						if (v > 1000) {
							v = v / 1000;
							if (v > 60) {
								v = v / 60;
								if (v > 60) {
									v = v / 60;
									m = 'h';
								} else {
									m = 'min';
								}
							} else {
								m = 's';
							}
							return `${v.toFixed(2)} ${m}`;
						} else {
							return `${v} ${m}`;
						}
					}
				};
			}
			return this.usageFormats[f](v);
		}
	}
};
</script>

<style>
.light .metric__card {
	border: 1px solid #d8d8d8;
}
.dark .metric__card {
	border: 1px solid #4d4b4b;
}
.light .metric__heading {
	color: #212529;
	border-bottom: 1px solid #b8b8b8;
}
.dark .metric__heading {
	color: #fafafa;
	border-bottom: 1px solid #cecdcd;
}
.light .metric__details {
	color: #7a7a7a;
}
.dark .metric__details {
	color: #cecdcd;
}
.metric__card {
	padding: 14px;
	border-radius: 2px;
}
.metric__heading {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 14px;
	padding-bottom: 10px;
}
.metric__details {
	font-size: 12px;
	margin-top: 10px;
}
.metric__det-row {
	display: flex;
	align-items: center;
}
.metric__det-name {
	display: block;
	flex: 2;
}
.metric__det-calc {
	display: block;
	flex: 1;
	text-align: right;
	white-space: pre;
}
.metric__det-price {
	display: block;
	flex: 1;
	text-align: right;
	white-space: pre;
}
.metric__det-row {
	line-height: 24px;
}
.span-1 {
	grid-column-end: span 1;
}
.span-2 {
	grid-column-end: span 2;
}
.span-3 {
	grid-column-end: span 3;
}
</style>